import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';

import './DialogMUI.scss';
import '../../assets/icons/left.svg';

import {ReactComponent as CloseIcon} from './icons/close.svg';

const DialogMUI = ({
                       open,
                       onClose,
                       className = '',
                       children,
                       fullScreen = false,
                       fullWidth = false,
                       title,
                       maxWidth = 'sm',
                       withoutDefaultWrapper = false,
                       isClosable = true
                   }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            className={className}
            classes={{
                root: 'dialog-mui',
                paper: 'dialog-mui__paper'
            }}
            fullWidth={fullWidth}
            fullScreen={fullScreen}
        >
            {!withoutDefaultWrapper ? (
                <div className='dialog-mui__content'>
                    <div className='dialog-mui__header'>
                        {title ? <h4 className={'dialog-mui__title'}>{title}</h4> : null}
                        {isClosable && (
                            <button onClick={onClose} className='dialog-mui__close-button'
                                    aria-label='Close dialog button'>
                                <CloseIcon className='dialog-mui__close-icon'/>
                            </button>
                        )}
                    </div>
                    {children}
                </div>
            ) : (
                <div className={'dialog-mui__fullContent'}>{children} </div>
            )}
        </Dialog>
    );
};

DialogMUI.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    maxWidth: PropTypes.string,
    fullScreen: PropTypes.bool,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
    withoutDefaultWrapper: PropTypes.bool,
    isClosable: PropTypes.bool
};

export default DialogMUI;
